import { useContext } from 'react';
import { FILTERS_PROVIDER_UI_REFS } from '../consts';

const useUiRefs = Context => {
  const {
    state: {
      uiRefs: {
        [FILTERS_PROVIDER_UI_REFS.TRIGGER_FILTER_MENUS_BUTTON]:
          triggerFiltersMenuButtonRef
      }
    }
  } = useContext(Context);

  return {
    triggerFiltersMenuButtonRef
  };
};

export default useUiRefs;
